<template>
    <CBreadcrumb :items="items" />
</template>

<script>
    import Vue from 'vue';

    export default {
        data() {
            return {
                items: [],
                isAuthorized: false,
            };
        },

        computed: {},

        watch: {
            $route() {
                this.getItems();
            },
        },

        created() {
            this.getItems();
        },

        methods: {
            async getItems() {
                const params = this.$route.params;

                const paths = [];
                this.$route.matched.forEach(element => {
                    paths.push({
                        path: element.path,
                        title: element.meta.label,
                    });
                });
                if (paths.length > 1) {
                    if (
                        paths[paths.length - 1].path ===
                        paths[paths.length - 2].path + '/'
                    ) {
                        paths.length = paths.length - 1;
                    }
                }
                paths[paths.length - 1].noLink = true;

                const items = [];
                for (var i = 0; i < paths.length; i++) {
                    var item = {
                        text: await this.getText(paths[i], params),
                    };
                    if (!paths[i].noLink) {
                        item.to = this.getTo(paths[i].path, params);
                    }
                    items.push(item);
                }
                this.items = items;
            },
            getTo(path, params) {
                if (!path) {
                    return '/';
                }
                for (var key in params) {
                    path = path.replace(':' + key, params[key]);
                }
                return path;
            },
            async getText(item, params) {
                // Home
                if (item.path === '') {
                    return 'Главная';
                }
                // If we have title - use it
                if (item.title) {
                    return `${item.title}`;
                }
                switch (item.path) {
                case '/other-delivery/:id':
                    return `Доставка ID ${params.id}`;
                case '/orders/:id':
                    return 'Заказ #' + params.id;
                case '/orders/orders-ed/:entityTypeId':
                    return await this.getEntityType(params.entityTypeId);
                case '/partners/:id':
                    return await this.getPartner(params.id);
                case '/vip-partners/:id':
                    return await this.getVipPartner(params.id);
                case '/vip-partners/orders/:order_id':
                case '/vip-partners/:id/orders/:order_id':
                    return await this.getVipPartnerOrder(params.order_id);
                case '/promocodes/:id':
                    return await this.getPromocode(params.id);
                case '/restaurants/:id':
                    return await this.getRestaurant(params.id);
                case '/restaurants/:id/dishes/:dish_id':
                    return await this.getDish(params.id, params.dish_id);
                case '/restaurants/:id/promotions/:promotion_id':
                    return await this.getPromotion(params.promotion_id);
                case '/customers/:id':
                    return await this.getCustomer(params.id);
                case '/business-companies/:id':
                    return await this.getCompany(params.id);
                case '/administrators/:id':
                    return await this.getAdministrator(params.id);
                case '/categories/:id':
                    return await this.getCategory(params.id);
                case '/grocers/:id':
                    return await this.getGrocer(params.id);
                case '/grocers/:id/goods/:goods_id':
                    return await this.getGoods(params.id, params.goods_id);
                case '/pharmacies/:id':
                    return await this.getPharmacy(params.id);
                case '/pharmacies/:id/drugs/:drug_id':
                    return await this.getDrug(params.id, params.drug_id);
                case '/partners/:id/discount-cards/:discount_card_id':
                    return await this.getDiscountCard(
                        params.discount_card_id
                    );
                case '/partners/:id/:code':
                    return await this.getEntityType(params.code);
                case '/assistants/:id':
                    return await this.getAssistant(params.id);
                case '/assistants/:id/promotions/:promotion_id':
                    return await this.getPromotion(params.promotion_id);
                case '/assistants/:id/service/:service_id':
                    return await this.getAssistantService(
                        params.id,
                        params.service_id
                    );
                case '/couriers/:id':
                    return await this.getCourier(params.id);
                case '/concierges/:id':
                    return await this.getConcierge(params.id);
                case '/banners/:id':
                    return await this.getBanner(params.id);
                case '/demands/:id':
                    return await this.getDemand(params.id);
                case '/ads-places/:id':
                    return await this.getAdsPlace(params.id);
                case '/entities/:code':
                    return await this.getEntityType(params.code);
                case '/settings/entities/:id':
                    return await this.getEntityType(params.id);
                case '/entities/:code/:id':
                    return await this.getEntity(params.id);
                case '/entities/:code/:id/promotions/:promotion_id':
                    return await this.getPromotion(params.promotion_id);
                case '/entities/:code/:id/products/:entity_product_id':
                    return await this.getEntityProduct(params.id, params.entity_product_id);
                case '/restaurants/:id/dishes/:dish_id/modifier-groups/:group_id':
                    return await this.getDishModifierGroup(params.id, params.group_id);
                case '/restaurants/:id/dishes/:dish_id/ingredient-groups/:group_id':
                    return await this.getDishIngredientGroup(params.id, params.group_id);
                case '/promotions/:id':
                    return await this.getPromotion(params.id);
                case '/stories/:id':
                    return await this.getStories(params.id);
                case '/onboarding/:id':
                    return await this.getOnboarding(params.id);
                case '/ads-campaigns/:id':
                    return await this.getAdsCampaigns(params.id);
                case '/surveys/:id':
                    return await this.getSurvey(params.id);
                case '/surveys/:id/questions/:question_id':
                    return 'Вопрос';
                case '/surveys/:id/results/:customer_id':
                    return await this.getCustomer(params.customer_id);
                
                case '/segments/:id':
                    return await this.getSegment(params.id);
                case '/ab-tests/:id':
                    return await this.getABTest(params.id);
                case '/trigger-campaigns/:id':
                    return await this.getTriggerCampaign(params.id);
                default:
                    return item.path;
                }
            },
            async getPartner(id) {
                return Vue.axios
                    .get('/partners/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getVipPartner(id) {
                return Vue.axios
                    .get('/vip-partners/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getVipPartnerOrder(order_id) {
                return Vue.axios
                    .get(`/vip-partners/orders/${order_id}`)
                    .then(resp => {
                        return resp.data.description ? resp.data.description : resp.data.invoice_id;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getPromocode(id) {
                return Vue.axios
                    .get('/promocodes/' + id)
                    .then(resp => {
                        return resp.data.code;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getRestaurant(id) {
                return Vue.axios
                    .get('/restaurants/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getDish(id, dish_id) {
                return Vue.axios
                    .get('/restaurants/' + id + '/dishes/' + dish_id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getPromotion(id) {
                return Vue.axios
                    .get('/promotions/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getStories(id) {
                return Vue.axios
                    .get('/stories/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getOnboarding(id) {
                return Vue.axios
                    .get('/onboarding/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getAdsCampaigns(id) {
                return Vue.axios
                    .get('/ads-campaigns/' + id)
                    .then(resp => {
                        return resp.data.name;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getCustomer(id) {
                return Vue.axios
                    .get('/customers/get/' + id)
                    .then(resp => {
                        return resp.data.phone;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getCompany(id) {
                return Vue.axios
                    .get('/companies/' + id)
                    .then(resp => {
                        return resp.data.title || 'Компания';
                    })
                    .catch(() => {
                        return 'Компания';
                    });
            },
            async getAdministrator(id) {
                return Vue.axios
                    .get('/administrators/' + id)
                    .then(resp => {
                        return resp.data.name;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getCategory(id) {
                return Vue.axios
                    .get('/categories/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getGrocer(id) {
                return Vue.axios
                    .get('/grocers/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getGoods(id, goods_id) {
                return Vue.axios
                    .get(`/grocers/${id}/goods/${goods_id}`)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getPharmacy(id) {
                return Vue.axios
                    .get('/pharmacies/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getDrug(id, drug_id) {
                return Vue.axios
                    .get(`/pharmacies/${id}/drugs/${drug_id}`)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getDiscountCard(discount_card_id) {
                return Vue.axios
                    .get('/discount-cards/' + discount_card_id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getAssistant(id) {
                return Vue.axios
                    .get('/assistants/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getAssistantService(id, service_id) {
                return Vue.axios
                    .get(`/assistants/${id}/services/${service_id}`)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getCourier(id) {
                return Vue.axios
                    .get('/couriers/' + id)
                    .then(resp => {
                        return resp.data.name;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getConcierge(id) {
                return Vue.axios
                    .get('/concierges/' + id)
                    .then(resp => {
                        return resp.data.name;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getBanner(id) {
                return Vue.axios
                    .get('/banners/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getDemand(id) {
                return Vue.axios
                    .get('/demands/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getAdsPlace(id) {
                return Vue.axios
                    .get('/ads-places/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getEntityType(id) {
                return Vue.axios
                    .get('/entities-type/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getEntity(id) {
                return Vue.axios
                    .get('/entities/get/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getEntityProduct(id, entity_product_id) {
                return Vue.axios
                    .get(`/entities/${id}/entity_products/${entity_product_id}`)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getDishModifierGroup(restaurantId, groupId) {
                return Vue.axios
                    .get(`/restaurants/${restaurantId}/dishes/modifiers-group/${groupId}`)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getDishIngredientGroup(restaurantId, groupId) {
                return Vue.axios
                    .get(`/restaurants/${restaurantId}/dishes/ingredients-group/${groupId}`)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getSurvey(id) {
                return Vue.axios
                    .get('/surveys/' + id)
                    .then(resp => {
                        return resp.data.title;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getSegment(id) {
                return Vue.axios
                    .get('/segments/' + id)
                    .then(resp => {
                        return resp.data.name;
                    })
                    .catch(() => {
                        return '???';
                    });
            },
            async getABTest(id) {
                return Vue.axios
                    .get('/ab-tests/' + id)
                    .then(resp => {
                        return resp.data.key;
                    })
            },
            async getTriggerCampaign(id) {
                return Vue.axios
                    .get('/trigger-campaigns/' + id)
                    .then(resp => {
                        return resp.data.name;
                    })
            },
        },
    };
</script>
